import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ParticlesBackground from './ParticlesBackground';

const PageLayout = ({
  title,
  subtitle,
  showLastUpdated = false,
  children,
  className = "",
  showParticles = true
}) => {
  return (
    <div className="min-h-screen bg-gray-100/60 dark:bg-gray-900/60 backdrop-blur-sm transition-colors duration-300 relative overflow-hidden">
      {showParticles && <ParticlesBackground />}
      <div className="container mx-auto px-4 py-8 relative z-10">
        <Header
          title={title}
          subtitle={subtitle}
          showLastUpdated={showLastUpdated}
        />

        <main className={`max-w-4xl mx-auto ${className}`}>
          {children}
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default PageLayout;
